<template>
	<div class="expert-score">
		<div class="container-fluid">
			<div class="wrapper" style="max-width:90%">
				<div class="content-page">
					<div class="content">
						<div class="row mb-1">
							<div class="col-xl-6">已结题</div>
							<div class="col-xl-6" style="display: flex;justify-content: flex-end;align-items: center;"><Breadcrumb></Breadcrumb></div>
						</div>
						<div class="card">
							<div class="card-body">
								<div class="mb-2">
									<el-form ref="form" :model="query" label-width="110px">
										<el-row :gutter="10">
											<el-col :span="5">
												<el-form-item label="课题名称:"><el-input v-model="query.name"></el-input></el-form-item>
											</el-col>
											<el-col :span="5">
												<el-form-item label="课题级别类别:">
													<!-- <el-cascader
														class="mr-2 mb-1"
														:options="subjectTypeOptions"
														:props="{ expandTrigger: 'hover', checkStrictly: true, label: 'name', value: 'id' }"
														placeholder="-课题类别-"
														clearable
														filterable
														@change="cascaderSubjectTypeChange"
													>
														<template slot-scope="{ node, data }">
															<span>{{ data.name }}</span>
															<span v-if="!node.isLeaf">({{ data.children.length }})</span>
														</template>
													</el-cascader> -->
													<el-select v-model="query.projectLevelId" clearable placeholder="请选择">
														<el-option
															v-for="item in subjectTypeOptions"
															:key="item.id"
															:label="item.name"
															:value="item.id">
														</el-option>
													</el-select>
												</el-form-item>
											</el-col>
											<el-col :span="5">
												<el-form-item label="负责人:"><el-input v-model="query.userName"></el-input></el-form-item>
											</el-col>
											<el-col :span="5">
												<el-form-item label="单位:"><el-input v-model="query.unitName"></el-input></el-form-item>
											</el-col>
										</el-row>
										<el-row :gutter="10">
											<el-col :span="5">
												<el-form-item label="结题年度:"><el-date-picker v-model="query.year" type="year" value-format="yyyy" placeholder="选择年"></el-date-picker></el-form-item>
											</el-col>
											<el-col :span="5">
												<el-form-item label="评审结果:">
													
													<el-select v-model="query.internResults" clearable placeholder="请选择">
														<el-option
															v-for="item in reviewResultOptions"
															:key="item.id"
															:label="item.name"
															:value="item.name">
														</el-option>
													</el-select>
													
												</el-form-item>
											</el-col>
											<el-col :span="14">
												<el-button type="primary" @click="searchData">查询</el-button>
												<el-button type="success" @click="exportExcel">导出Excel</el-button>
											</el-col>
										</el-row>
									</el-form>
								</div>
								<el-table
									id="table"
									:header-cell-style="tableHeaderStyle"
									ref="multipleTable"
									:data="list"
									tooltip-effect="dark"
									style="width: 100%"
									border
									@selection-change="handleSelectionChange"
								>
									<el-table-column type="selection" :selectable="isDisabled" width="55"></el-table-column>
									<el-table-column prop="declareName" label="课题名称" min-width="150"></el-table-column>
									<el-table-column prop="year" label="结题时间" min-width="80"></el-table-column>
									<el-table-column prop="projectLevelName" label="课题级别"  min-width="80"></el-table-column>
									<el-table-column prop="projectTypeName" label="课题类别"  min-width="80"></el-table-column>
									<el-table-column prop="learningTypeName" label="学段"  min-width="100"></el-table-column>
									<el-table-column prop="disciplineName" label="学科"  min-width="100"></el-table-column>
									<el-table-column prop="oneUnitName" label="所属单位"  width="80"></el-table-column>
									<el-table-column prop="oneEmceeName" label="负责人"  width="80"></el-table-column>
									<el-table-column prop="results" label="评审结果" sortable width="80"></el-table-column>
									<el-table-column prop="coreMemberNumber" label="核心成员数"  width="80"></el-table-column>
									<el-table-column prop="certificateNumber" label="结题证书编号"  width="80"></el-table-column>
								</el-table>
								<div class="mt-2">
									<el-button class="mr-1" type="primary" @click="openSetTheCertificateLabelDialog">设置证书编号</el-button>
									<el-button class="mr-1" type="warning" @click="toUpdate(0)">导出结题证书</el-button>
								</div>
								<!-- 分页器 -->
								<div class="text-right mt-2">
									<el-pagination
										layout="total, sizes, prev, pager, next, jumper"
										background
										:current-page="query.pageNumber"
										:page-sizes="[10, 50, 100, 200]"
										:page-size="query.pageSize"
										:total="total"
										@size-change="handleSizeChange"
										@current-change="handlePageChange"
									></el-pagination>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		
		<el-dialog
		  title="请输入结题证书编号前缀"
		  :visible.sync="setTheCertificateLabelDialogVisible"
		  width="30%"
		  :before-close="handleClose">
		  
			<el-form :model="setTheCertificateLabelDialogForm" :rules="setTheCertificateLabelDialogRules" ref="setTheCertificateLabelDialogFormRef" label-width="100px" class="demo-setTheCertificateLabelDialogForm">
			  <el-form-item label="编号前缀" prop="certificateNumberPrefix">
			    <el-input v-model="setTheCertificateLabelDialogForm.certificateNumberPrefix"></el-input>
			  </el-form-item>
				<div style="color: red;text-align: center;margin-top: 10px;">(如：TGHJ2021)</div>
			</el-form>
			
		  <span slot="footer" class="dialog-footer">
		    <el-button @click="setTheCertificateLabelDialogVisible = false">取 消</el-button>
		    <el-button type="primary" @click="submitSet">确 定</el-button>
		  </span>
		</el-dialog>
		
	</div>
</template>

<script>
import { getAreaTree, getPlatformInformationData } from '@/api/after/systemManagement';
// import { getprojectDeclareQuasiList, auditProject } from '@/api/after/proposedProject';
import { getFinishedList,setTheCertificateLabel } from '@/api/after/topicManage.js'
import Breadcrumb from '@/views/backstage/components/Breadcrumb.vue';
import FileSaver from 'file-saver';
import XLSX from 'xlsx';
export default {
	name: 'proposedProject',
	components: {
		Breadcrumb
	},
	data() {
		return {
			setTheCertificateLabelDialogVisible:false,
			setTheCertificateLabelDialogForm:{
				certificateNumberPrefix:'',//结题编号前缀
				hasId:'',//已结题id
			},
			setTheCertificateLabelDialogRules:{
				certificateNumberPrefix:[{required:true,message:'请输入证书编号前缀',trigger:'blur'},{max:12,message:'长度不能超过12位！',trigger:'blur'}],
			},
			tableHeaderStyle: {
				backgroundColor: '#3083c5',
				color: '#fff',
				textAlign:'center',
			},
			tableSort: {
				prop: 'projectTypeName',
				prop: 'learningTypeName',
				prop: 'disciplineName',
				prop: 'unitName',
				prop: 'oneEmceeName',
				prop: 'internNumber',
				prop: 'internResults'
			},
			// areaOptions: [], //区域列表
			subjectTypeOptions: [], //课题类别
			//学段列表
			stageOptions: [
				{ id: '0', name: '幼儿园' },
				{ id: '1', name: '小学' },
				{ id: '2', name: '初中' },
				{ id: '3', name: '高中' },
				{ id: '4', name: '中/高职' },
				{ id: '5', name: '其他' }
			],
			// 立项状态
			projectStateOptions: [{ value: 0, label: '不予立项' }, { value: 1, label: '已立项' }],
			query: {
				// finalResults:'',//终评结果			
				internResults:'',//初评结果			
				name:'',//课题名称			
				pageNumber:1,//页码,默认为1,示例值(1)			
				pageSize:10,//页大小,默认为10,示例值(10)			
				// reviewResults:'',//复评结果			
				projectLevelId:'',//课题级别id			
				unitName:'',//单位			
				userName:'',//负责人名称			
				year:'',//立项年度
			},
			list: [],
			total: 0,
			multipleSelection: [], //被选中的项
			queryUpdate: { ids: [], type: 1 },
			reviewResultOptions:[],//评审结果
		};
	},
	mounted() {
		this.getData();
		this.getPlatformInformationData();
		this.getReviewResult()
	},
	methods: {
		// 提交设置
		submitSet(){
			this.setTheCertificateLabel()
		},
		// 打开设置证书编号前缀对话框
		openSetTheCertificateLabelDialog(){
			if (this.multipleSelection.length === 0) {
				this.$message.warning('请选择一个课题！')
				return
			}
			if (this.multipleSelection.length > 1) {
				this.$message.warning('只能选择一个课题!')
				return 
			}
			this.setTheCertificateLabelDialogVisible = true
			this.setTheCertificateLabelDialogForm.hasId = this.multipleSelection[0].hasId
		},
		// 设置证书编号
		async setTheCertificateLabel(){
			const res = await setTheCertificateLabel(this.setTheCertificateLabelDialogForm)
			if (res.code == 200) {
				this.$message.success('设置证书编号成功！')
				this.setTheCertificateLabelDialogVisible = false
				this.getData()
			}else{
				this.$message.error(res.data)
			}
		},
		// 获取数据列表
		getData(isNum) {
			if (isNum) this.query.pageNumber = 1;
			getFinishedList(this.query).then(res => {
				if (res.code == 200) {
					console.log('已结题数据',res);
					this.list = res.data.records;
					this.total = res.data.total;
				} else {
					this.$message.error(res.data);
				}
			});
		},
		// 获取区域树
		// getAreaTree() {
		//   getAreaTree().then((res) => {
		//     if (res.code == 200) {
		//       this.areaOptions = res.data;
		//     } else {
		//       this.$message.error(res.data);
		//     }
		//   });
		// },
		// 获取课题类别
		getPlatformInformationData() {
			getPlatformInformationData(1).then(res => {
				if (res.code == 200) {
					this.subjectTypeOptions = res.data;
				} else {
					this.$message.error(res.data);
				}
			});
		},
		// 搜索
		searchData() {
			this.getData(true);
		},
		//区域筛选
		cascaderChange(e) {
			let num = null;
			e.length <= 0 ? (num = null) : (num = e[e.length - 1]);
			this.query.regionId = num;
		},
		//课题类别筛选
		cascaderSubjectTypeChange(e) {
			let num = null;
			e.length <= 0 ? (num = null) : (num = e[e.length - 1]);
			this.query.projectTypeId = num;
		},
		// 配置表格禁止选中项
		isDisabled(row) {
			if (row.projectState === 1 || row.projectState === 0) {
				return 0;
			}
			return 1;
		},
		// 选择需要操作的项
		handleSelectionChange(val) {
			this.multipleSelection = val;
		},
		toUpdate(type) {
			if (this.multipleSelection.length <= 0) return;
			this.queryUpdate.type = type;
			this.queryUpdate.ids = this.multipleSelection.map(item => {
				return item.id;
			});
			if (type === 0) {
				this.$confirm('确定要将所选课题批准为 “不予立项” 吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.auditProject();
				});
			} else {
				this.auditProject();
			}
		},
		//立项或者不立项操作
		auditProject() {
			auditProject(this.queryUpdate).then(res => {
				if (res.code == 200) {
					this.$message.success('操作成功');
				} else {
					this.$message.error(res.data);
				}
				this.getData();
			});
		},
		// 导出表格
		exportExcel() {
			var xlsxParam = { raw: true };
			var wb = XLSX.utils.table_to_book(document.querySelector('#table'), xlsxParam);
			var wbout = XLSX.write(wb, {
				bookType: 'xlsx',
				bookSST: true,
				type: 'array'
			});
			try {
				FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), '已结题.xlsx');
			} catch (e) {
				if (typeof console !== 'undefined') {
					console.log(e, wbout);
				}
			}
			return wbout;
		},
		// 分页导航
		handlePageChange(val) {
			this.query.pageNumber = val;
			this.getData();
		},
		handleSizeChange(val) {
			this.query.pageSize = val;
			this.getData(true);
		},
		// 获取评审结果数据
		async getReviewResult(){
			const res = await getPlatformInformationData(10)
			if (res.code == 200) {
				console.log('评审结果信息',res);
				this.reviewResultOptions = res.data
			}else{
				this.$message.error(res.data)
			}
		},
		handleClose(done) {
		        this.$confirm('确认关闭？')
		          .then(_ => {
		            done();
		          })
		          .catch(_ => {});
		      }
	}
};
</script>

<style scoped lang="scss">
::v-deep .el-date-editor.el-input {
	width: 100% !important;
}
.card-body {
	padding: 1.5rem 0;
}
.mb-2,
.mt-2 {
	padding: 0 1.5rem;
}
.file_box {
	position: relative;
	display: flex;
	align-items: center;
	border: 1px dashed #d9d9d9;
	height: 30px;
	padding: 0 20px;
	cursor: pointer;
	max-width: calc(100% - 150px);
	margin: 5px 0;
}
.file_box p {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	max-width: 450px;
	margin-bottom: 0;
	line-height: normal;
}
.close_btn {
	position: absolute;
	top: -8px;
	right: -8px;
}
.wrap {
	background: #fafbfe;
	padding: 30px;
}
.con {
	min-height: 500px;
	background: #fff;
	padding: 30px;
	border-radius: 5px;
}
</style>
